import DeleteStep from './DeleteStep';
import { withPopup } from './Utils';

export default withPopup(DeleteStep);
